import { render, staticRenderFns } from "./iptalPolitikalariTanimla.vue?vue&type=template&id=a27aa1e4&scoped=true&"
import script from "./iptalPolitikalariTanimla.vue?vue&type=script&lang=js&"
export * from "./iptalPolitikalariTanimla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27aa1e4",
  null
  
)

export default component.exports